// Reconstructed from the supplied production build; original component names were unavailable.
import { AdminAuthProvider } from "./context/AdminAuthContext.jsx";
import { BrowserRouter, Navigate, Route, Routes } from "./vendor/runtime.js";
import { LoginPage } from "./pages/LoginPage.jsx";
import { ProtectedRoute } from "./components/ProtectedRoute.jsx";
import { DashboardPage } from "./pages/DashboardPage.jsx";
import { ProductsPage } from "./pages/ProductsPage.jsx";
import { ProductDetailsPage } from "./pages/ProductDetailsPage.jsx";
import { OrdersPage } from "./pages/OrdersPage.jsx";
import { AgentsPage } from "./pages/AgentsPage.jsx";
import { CouponsPage } from "./pages/CouponsPage.jsx";
import { PriceManagementPage } from "./pages/PriceManagementPage.jsx";
import { RequirementsPage } from "./pages/RequirementsPage.jsx";
import { SupportTicketsPage } from "./pages/SupportTicketsPage.jsx";
import { CertificateRequestsPage } from "./pages/CertificateRequestsPage.jsx";
import { AgentDetailsPage } from "./pages/AgentDetailsPage.jsx";
import { WithdrawalsPage } from "./pages/WithdrawalsPage.jsx";
import { AnalyticsPage } from "./pages/AnalyticsPage.jsx";
import { RegisterAgentPage } from "./pages/RegisterAgentPage.jsx";
import { UsersPage } from "./pages/UsersPage.jsx";
const App = () => (
  <AdminAuthProvider>
    <BrowserRouter>
      <Routes>
        <Route path={"/"} element={<LoginPage />} />
        <Route path={"/login"} element={<LoginPage />} />
        <Route
          path={"/admin"}
          element={
            <ProtectedRoute>
              <DashboardPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={"/admin/products"}
          element={
            <ProtectedRoute>
              <ProductsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={"/admin/products/:id"}
          element={
            <ProtectedRoute>
              <ProductDetailsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={"/admin/orders"}
          element={
            <ProtectedRoute>
              <OrdersPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={"/admin/agents"}
          element={
            <ProtectedRoute>
              <AgentsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={"/admin/coupons"}
          element={
            <ProtectedRoute>
              <CouponsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={"/admin/price-management"}
          element={
            <ProtectedRoute>
              <PriceManagementPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={"/admin/custom"}
          element={
            <ProtectedRoute>
              <RequirementsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={"/admin/support"}
          element={
            <ProtectedRoute>
              <SupportTicketsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={"/admin/certificates"}
          element={
            <ProtectedRoute>
              <CertificateRequestsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={"/admin/agents/:id"}
          element={
            <ProtectedRoute>
              <AgentDetailsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={"/admin/withdrawals"}
          element={
            <ProtectedRoute>
              <WithdrawalsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={"/admin/analytics"}
          element={
            <ProtectedRoute>
              <AnalyticsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={"/admin/register-agent"}
          element={
            <ProtectedRoute>
              <RegisterAgentPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={"/admin/users"}
          element={
            <ProtectedRoute>
              <UsersPage />
            </ProtectedRoute>
          }
        />
        <Route path={"/admin/*"} element={<Navigate to={"/admin"} replace={true} />} />
      </Routes>
    </BrowserRouter>
  </AdminAuthProvider>
);
export { App };
